(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Add click event listener to each tab button
    let collections_with_tab = [...document.querySelectorAll(".collections-with-tab")];
    collections_with_tab.forEach(collection_tab_section => {
      collection_tab_section.querySelectorAll(".tab-btns .button").forEach(tab_btn => {
        tab_btn.addEventListener("click", function () {
          let target = tab_btn.getAttribute("data-target");
          let data_url = tab_btn.getAttribute("data-url");
          let data_text = tab_btn.getAttribute("data-link-text");

          // Change the link text
          collection_tab_section.querySelector(".section-header a .reversed-link").innerHTML = data_text;
          collection_tab_section.querySelector(".section-header a").setAttribute("href", data_url);

          // Remove 'active' class from all tab content and buttons
          document.querySelectorAll(".tab-content").forEach(tab_content => {
            tab_content.classList.remove("active");
          });
          document.querySelectorAll(".tab-btns .button").forEach(btn => {
            btn.classList.remove("active");
          });

          // Add 'active' class to the clicked button and its corresponding tab content
          tab_btn.classList.add("active");
          document.querySelector(".tab-content." + target).classList.add("active");

          // Center the active button if it's scrollable
          const tabBtns = collection_tab_section.querySelector(".tab-btns");
          const activeBtn = tab_btn;

          // Scroll the button into view, centered within the container
          const btnOffsetLeft = activeBtn.offsetLeft;
          const btnWidth = activeBtn.offsetWidth;
          const containerWidth = tabBtns.offsetWidth;

          // Calculate the scroll position to center the button
          const scrollLeft = btnOffsetLeft - (containerWidth / 2) + (btnWidth / 2);

          // Scroll to the calculated position
          tabBtns.scrollTo({
            left: scrollLeft,
            behavior: 'smooth' // You can change to 'auto' for an instant scroll
          });
        });
      });
    });
    document.body.setAttribute("collection-layout", "multi");
    $("body").on("click", "[data-collection-layout-toggle]", function () {
      var layout = $(this).attr("data-collection-layout-toggle");
      $("body").attr("collection-layout", layout);
    });
  });
  var $slider = jQuery('.qv-product-images').flickity({ wrapAround: true });
  jQuery(document).on("click", ".quick-btn-link", function (e) {

    $slider.flickity('destroy');
    jQuery(".qv-product-title").html("")
    jQuery(".qv-modal .qv-content .qv-info").html("");
    jQuery(".qv-product-images").html("");
    jQuery(".qv-modal").addClass("shw");
    let productHandle = jQuery(this).attr("data-id");
    let newHtml = "";
    var url = theme.routes.home + '/products/' + productHandle + '?view=modal';

    url = url.replace('//', '/');

    fetch(url).then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');


      newHtml = doc.querySelector('.product-info');


      let images = doc.querySelectorAll('.product-gallery__media img');
      let productTitle = doc.querySelectorAll('.product-info__title');;
      let imageHtml = '';
      images.forEach(e => {
        imageHtml += '<div class="carousel-cell">' + e.outerHTML + '</div>';
      })


      jQuery(".qv-product-title").html(productTitle)
      jQuery(".qv-modal .qv-content .qv-info").html(newHtml);
      jQuery(".qv-product-images").html(imageHtml);

      setTimeout(function () {
        $slider.flickity({ prevNextButtons: false, wrapAround: true })
      }, 200);

    });

    return;
  })
  jQuery(".close-qv,.qv-modal-overlay").on("click", function () {
    jQuery(".qv-modal").removeClass("shw")
  })
})();


function initReadMore() {
  const wrapper = document.querySelector("read-more-description");
  if (!wrapper) return;

  const contentWrapper = wrapper.querySelector(".metafield-rich_text_field");
  const button = wrapper.querySelector(".read-more__button");

  if (!contentWrapper || !button) return;

  const items = contentWrapper.querySelectorAll(":scope > *");

  // Hide button if 2 or fewer items
  if (items.length <= 2) {
    button.style.display = "none";
    return;
  }

  // Reset visibility
  items.forEach(item => item.style.display = "block");

  // Hide after first 2
  items.forEach((item, index) => {
    if (index > 1) {
      item.style.display = "none";
    }
  });

  // One-time expand
  button.onclick = function () {
    items.forEach(item => item.style.display = "block");

    // Remove button after expanding
    button.remove();
  };
}

document.addEventListener("DOMContentLoaded", initReadMore);
document.addEventListener("shopify:section:load", initReadMore);


document.addEventListener("DOMContentLoaded", () => {

  const drawer = document.querySelector("#CartDrawer");
  const closeBtn = drawer.querySelector(".close-cart");
  const storeCurrency = window.currency_symbol;
  document.querySelectorAll(".milestone").forEach((milestone) => {
    // let rate = Number(Shopify.currency.rate);
    let rate = 1;
    let milestonePrice = Number(milestone.dataset.threshold);
    let milestoneAmount = milestonePrice * rate;
    milestone.setAttribute("data-threshold", milestoneAmount.toFixed(2));
  })
  /* -----------------------------
     Helper – Fetch Latest Cart
  ------------------------------ */


  function fetchCart() {
    return fetch("/cart.js").then(res => res.json());
  }

  if (drawer.querySelectorAll(".cart-item").length < 1) {
    drawer.classList.add("is-empty");
    document.querySelector(".count-bubble").classList.remove('cart-link__bubble--visible');
  }
  else {
    drawer.classList.remove("is-empty");
    document.querySelector(".count-bubble").classList.add('cart-link__bubble--visible');
  }

  /* -----------------------------
     Render Cart After Updates
  ------------------------------ */
  window.reloadCart = function () {
    fetch(window.location.pathname + "?section_id=cart-drawer-copy")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newDrawer = doc.querySelector("#CartDrawer");
        let items = newDrawer.querySelector(".cart-items");
        drawer.querySelector(".cart-items").innerHTML = items.innerHTML;
        const cartFooter = newDrawer.querySelector(".cart-footer");
        drawer.querySelector(".cart-footer").innerHTML = cartFooter.innerHTML;
        const upsellBox = newDrawer.querySelector(".upsell-box");
        drawer.querySelector(".upsell-box").innerHTML = upsellBox.innerHTML;

        const cartCount = newDrawer.querySelector(".cart-item-count");
        drawer.querySelector(".cart-item-count").innerHTML = cartCount.innerHTML;
        if (items.querySelectorAll(".cart-item").length == 0) {
          drawer.querySelector(".cart-item-count").innerHTML = 0;
        }
        else {
          if (drawer.querySelector("#shipping_protection_product")) {
            let shippingProtection_enabled = drawer.querySelector("#shipping_protection_product").checked;
            if (shippingProtection_enabled) {
              let cart__item_count = Number(cartCount.innerHTML);
              cart__item_count = cart__item_count - 1;
              drawer.querySelector(".cart-item-count").innerHTML = cart__item_count;
              document.querySelector(".count-bubble").innerHTML = cart__item_count;
            }
          }
        }
        attachCartEvents(); // rebind events
        if (items.querySelectorAll(".cart-item").length < 1) {
          drawer.classList.add("is-empty");
          document.querySelector(".count-bubble").classList.remove('cart-link__bubble--visible');
          document.querySelector(".count-bubble").innerHTML = 0;
        }
        else {
          drawer.classList.remove("is-empty");
          document.querySelector(".count-bubble").classList.add('cart-link__bubble--visible');
          document.querySelector(".count-bubble").innerHTML = drawer.querySelector(".cart-item-count").innerHTML;
        }
      });
  }
  window.checkCartCount = function () {
    fetch(window.location.pathname + "?section_id=cart-drawer-copy")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newDrawer = doc.querySelector("#CartDrawer");
        let items = newDrawer.querySelector(".cart-items");
        if (items.querySelectorAll(".cart-item").length == 0) {
          drawer.querySelector(".cart-item-count").innerHTML = 0;
          document.querySelector(".count-bubble").innerHTML = 0;
        }
        else {
          document.querySelector(".count-bubble").classList.add('cart-link__bubble--visible');
          let shippingProtection_enabled = drawer.querySelector("#shipping_protection_product").checked;
          const cartCount = newDrawer.querySelector(".cart-item-count");
          if (shippingProtection_enabled) {
            let cart__item_count = Number(cartCount.innerHTML);
            cart__item_count = cart__item_count - 1;
            drawer.querySelector(".cart-item-count").innerHTML = cart__item_count;
            document.querySelector(".count-bubble").innerHTML = cart__item_count;
          }
        }
        return items.querySelectorAll(".cart-item").length
      });
  }

  /* -----------------------------
     Open Drawer
  ------------------------------ */
  window.openCart = function () {
    drawer.classList.add("drawer--is-open");
    if (drawer.querySelectorAll(".cart-item").length < 1) {
      drawer.classList.add("is-empty");
      document.querySelector(".count-bubble").classList.remove('cart-link__bubble--visible');
      document.querySelector(".count-bubble").innerHTML = 0;
    }
    else {
      drawer.classList.remove("is-empty");
      document.querySelector(".count-bubble").classList.add('cart-link__bubble--visible');
      document.querySelector(".count-bubble").innerHTML = drawer.querySelector(".cart-item-count").innerHTML;
    }
  };

  /* -----------------------------
     Close Drawer
  ------------------------------ */
  closeBtn.addEventListener("click", () => {
    drawer.classList.remove("drawer--is-open");
  });

  document.querySelector(".cart-drawer-overlay").addEventListener("click", function (e) {
    e.preventDefault();
    drawer.classList.remove("drawer--is-open");
  })
  /* -----------------------------
     Update Quantity
  ------------------------------ */
  function updateCartLine(lineKey, quantity, triggerEl = null) {

    // Add updating class
    if (triggerEl) {
      triggerEl.classList.add("is-updating");
      triggerEl.disabled = true;
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity })
    })
      .then(() => reloadCart())
      .finally(() => {
        if (triggerEl) {
          triggerEl.classList.remove("is-updating");
          triggerEl.disabled = false;
        }
      });
  }


  /* -----------------------------
     Remove Item
  ------------------------------ */
  function removeItem(lineKey, btn = null) {
    return updateCartLine(lineKey, 0, btn);
  }

  /* -----------------------------
     Add Product / Upsell
  ------------------------------ */
  function addToCart(variantId, quantity = 1) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity })
    })
      .then(() => reloadCart())
      .then(() => openCart());
  }

  /* -----------------------------
     Handle Shipping Protection
  ------------------------------ */
  function toggleShippingProtection(enabled, variantId) {
    fetchCart().then(cart => {
      const alreadyAdded = cart.items.find(i => i.id == variantId);
      if (enabled && !alreadyAdded) {
        addToCart(variantId);
      } else if (!enabled && alreadyAdded) {
        removeItem(alreadyAdded.key);
      }
    });
  }

  window.toggleFreeProduct = function (enabled, variantId) {
    fetchCart().then(cart => {
      const alreadyAdded = cart.items.find(i => i.id == variantId);
      if (enabled && !alreadyAdded) {
        addToCart(variantId);
      } else if (!enabled && alreadyAdded) {
        removeItem(alreadyAdded.key);
      }
    });
  }
  /* -----------------------------
     Free Shipping Bar Logic
  ------------------------------ */
  function updateShippingBar(cart) {
    const settings = window.cartSettings || {};
    let cartTotal = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
    let country = Shopify.country;
    if (Shopify.currency.active == "EUR") {
      country = "EUROZONE";
    }
    let rate = 1; //Number(Shopify.currency.rate);
    // if (country!=="AU" && country !== "US" && country !== "CA" && country !== "GB") {
    //   rate = Number(Shopify.currency.rate);
    // }
    if (!window.freeShippingData[country]) {
      document.body.classList.add("no-shipping-bar")
      return;
    }
    const shipping_protection_price = Number(document.querySelector(".shipping_protection_product_price").dataset.price);
    const shipping_protection_enabled = document.querySelector("#shipping_protection_product").checked;
    if (shipping_protection_enabled) {
      cartTotal = cartTotal - shipping_protection_price;
    }
    const messageEl = document.querySelector("#amount-away");
    const milestones = Array.from(document.querySelectorAll(".milestone"));
    if (!messageEl || milestones.length === 0) return;

    // Sort milestones
    milestones.sort((a, b) => Number(a.dataset.threshold) - Number(b.dataset.threshold));
    const thresholds = milestones.map(m => Number(m.dataset.threshold) * 100);

    // Step-by-step fill
    milestones.forEach((milestone, idx) => {
      const current = thresholds[idx];
      const prev = idx === 0 ? 0 : thresholds[idx - 1];
      let percent = 0;

      if (cartTotal >= current) {
        percent = 100;
        milestone.classList.add("active");
      } else if (cartTotal > prev) {
        percent = ((cartTotal - prev) / (current - prev)) * 100;
        milestone.classList.remove("active");
      } else {
        milestone.classList.remove("active");
      }
      milestone.style.setProperty("--milestone-width", `${Math.min(100, percent)}%`);
    });

    function formatCents(cents) {
      return `${storeCurrency}${(Math.max(0, cents) / 100).toFixed(2)}`;
    }

    // -------------------------
    // DETERMINE ONLY THE NEXT MILESTONE
    // -------------------------

    const freeShippingUnlocked = settings.free_shipping_enabled && cartTotal >= Number(settings.free_shipping_threshold * rate);
    const freeGiftUnlocked = settings.enable_free_gift && cartTotal >= Number(settings.free_gift_threshold * rate);
    const expressUnlocked = settings.free_express_shipping_enabled && cartTotal >= Number(settings.free_express_shipping_threshold * rate);

    let nextMessage = "";

    // 1. Next: Free Shipping
    if (settings.enable_free_gift && !freeGiftUnlocked) {
      const diff = Number(settings.free_gift_threshold * rate) - cartTotal;
      nextMessage = settings.free_gift_text.replace("{{price}}", formatCents(diff));

    }

    // 2. Next: Free Gift
    else if
      (settings.free_shipping_enabled && !freeShippingUnlocked) {
      const diff = Number(settings.free_shipping_threshold * rate) - cartTotal;
      nextMessage = settings.free_shipping_text.replace("{{price}}", formatCents(diff));
    }

    // 3. Next: Free Express
    else if (settings.free_express_shipping_enabled && !expressUnlocked) {
      const diff = Number(settings.free_express_shipping_threshold * rate) - cartTotal;
      nextMessage = settings.free_express_shipping_text.replace("{{price}}", formatCents(diff));
    }

    // 4. ALL unlocked
    else {
      if (window.freeExpressShippingData[country]) {
        nextMessage = settings.free_shipping_final_message;
      }
      else {
        nextMessage = settings.free_shipping_final_message_others;
      }
    }
    if (settings.enable_free_gift && freeGiftUnlocked) {
      toggleFreeProduct(true, settings.free_product_product_id);
    }
    else {
      toggleFreeProduct(false, settings.free_product_product_id);
    }
    messageEl.innerHTML = nextMessage;
  }



  /* -----------------------------
     Attach Events to Drawer
  ------------------------------ */
  function attachCartEvents() {
    drawer.querySelectorAll(".plus").forEach(btn => {
      btn.addEventListener("click", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        const qtyInput = item.querySelector("input");
        updateCartLine(key, Number(qtyInput.value) + 1, btn);
      });
    });

    drawer.querySelectorAll(".minus").forEach(btn => {
      btn.addEventListener("click", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        const qtyInput = item.querySelector("input");
        const newQty = Math.max(0, Number(qtyInput.value) - 1);
        updateCartLine(key, newQty, btn);
      });
    });
    drawer.querySelectorAll("[type='number']").forEach(input => {
      input.addEventListener("focusout", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        const qtyInput = item.querySelector("input");
        const newQty = Math.max(1, Number(qtyInput.value));
        updateCartLine(key, newQty);
      });
    });

    drawer.querySelectorAll(".remove").forEach(btn => {
      btn.addEventListener("click", e => {
        const item = e.target.closest(".cart-item");
        const key = item.dataset.itemId;
        removeItem(key, btn);
      });
    });

    drawer.querySelectorAll(".add-to-cart").forEach(btn => {
      btn.addEventListener("click", e => {
        const id = e.target.dataset.variantId;
        addToCart(id, btn);
      });
    });
    if (document.querySelector('#CartNote')) {
      document.querySelector('#CartNote').addEventListener('focusout', function (e) {
        updateCartNote(e.target.value);
      });

      document.querySelector(".cart-note-toggler").addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector(".cart-note-wrap").classList.toggle("is-active");
      })
    }

    // SHIPPING PROTECTION
    if (document.querySelector("#shipping_protection_product")) {
      const spCheckbox = document.querySelector("#shipping_protection_product");
      if (spCheckbox) {
        const spVariant = spCheckbox.getAttribute("data-id");

        spCheckbox.addEventListener("change", () => {
          toggleShippingProtection(spCheckbox.checked, spVariant);
        });
      }
    }

    // Update shipping bar after render
    fetchCart().then(cart => updateShippingBar(cart));
  }


  /* Init */
  attachCartEvents();

  function updateCartState(cart) {
    if (window.checkCartCount() == undefined) {
      document.querySelector(".count-bubble").classList.remove('cart-link__bubble--visible');
    }
    else {
      document.querySelector(".count-bubble").classList.add('cart-link__bubble--visible');
    }
  }
  function addOrIncrementCartItem(variantId, triggerEl = null) {

    // Add loading class
    if (triggerEl) {
      triggerEl.classList.add("is-updating");
      triggerEl.disabled = true;
    }

    jQuery.getJSON('/cart.js', function (cart) {

      let lineIndex = null;
      let currentQty = 0;

      cart.items.forEach((item, index) => {
        if (item.variant_id == variantId) {
          lineIndex = index + 1;
          currentQty = item.quantity;
        }
      });

      const onDone = () => {
        reloadCart();
        openCart();

        // Remove loading state
        if (triggerEl) {
          triggerEl.classList.remove("is-updating");
          triggerEl.disabled = false;
        }
      };

      if (lineIndex) {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { line: lineIndex, quantity: currentQty + 1 },
          dataType: 'json',
          success: onDone,
          error: onDone
        });
      } else {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: variantId, quantity: 1 },
          dataType: 'json',
          success: onDone,
          error: onDone
        });
      }
    });
  }

  fetchCart().then(cart => updateCartState(cart));



  document.querySelector('[aria-controls="cart-drawer"]').addEventListener("click", function (e) {
    e.preventDefault();
    openCart();
  });
  window.checkCartCount();


  function updateCartNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    })
      .then(res => res.json())
      .then(cart => {
      })
      .catch(err => console.error("Note update failed:", err));
  }

  document.querySelectorAll(".accordion-menu .accordion-toggle").forEach(button => {
    button.addEventListener("click", function () {
      const content = this.nextElementSibling;

      this.classList.toggle("active");

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });


})

document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".product-card__figure");

  cards.forEach(card => {
    let touched = false;

    card.addEventListener("touchstart", function () {
      const primary = card.querySelector(".product-card__image--primary");
      const secondary = card.querySelector(".product-card__image--secondary");

      if (!primary || !secondary) return;

      // Reset all other cards
      document.querySelectorAll(".product-card__figure").forEach(c => {
        c.classList.remove("touch-active");
      });

      // Toggle current
      if (!touched) {
        card.classList.add("touch-active");
        touched = true;
      } else {
        card.classList.remove("touch-active");
        touched = false;
      }
    });
  });
});

document.querySelectorAll('.quantity-info-btn').forEach(btn => {
  const tooltip = document.getElementById(btn.getAttribute('aria-controls'));

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = !tooltip.hidden;
    tooltip.hidden = isOpen;
    btn.setAttribute('aria-expanded', String(!isOpen));
  });

  document.addEventListener('click', () => {
    tooltip.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
  });

  btn.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      tooltip.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const uploadery = document.querySelector('[data-uploadery]');

    if (uploadery) {
      clearInterval(interval);

      const customUI = document.createElement('div');
      customUI.className = 'custom-upload';

      customUI.innerHTML = `
        <div class="uploadery__container">
          <div class="th-c-images__uploads-container">
            <div class="th-c-images__upload-tile th-c-images__upload-tile--placeholder">
              <svg class="th-customiser__icon th-customiser__icon--plus-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.473751 10C0.473751 9.50245 0.877098 9.0991 1.37465 9.0991L18.6255 9.0991C19.1231 9.0991 19.5264 9.50245 19.5264 10C19.5264 10.4976 19.1231 10.9009 18.6255 10.9009L1.37465 10.9009C0.877098 10.9009 0.473751 10.4976 0.473751 10Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0001 0.473671C10.4976 0.47367 10.901 0.877017 10.901 1.37457V18.6254C10.901 19.123 10.4976 19.5263 10.0001 19.5263C9.50253 19.5263 9.09918 19.123 9.09918 18.6254V1.37457C9.09918 0.877018 9.50253 0.47367 10.0001 0.473671Z" fill="white"/>
              </svg>
            </div>
          </div>
          <button class="upload-btn" id="customUploadBtn">+ Add an image</button>
        </div>
      `;

      uploadery.parentNode.insertBefore(customUI, uploadery.nextSibling);
      initUploadLogic();
    }
  }, 500);
});

function initUploadLogic() {
  const input = document.querySelector('[data-uploadery] input[type="file"]');
  const box = document.querySelector('.th-c-images__upload-tile');
  const btn = document.getElementById('customUploadBtn');

  if (!input || !box || !btn) return;

  let hasImage = false;

  // Trigger file input
  box.addEventListener('click', () => {
    // Only trigger if clicking the box itself, not the X button
    if (!hasImage) input.click();
  });

  btn.addEventListener('click', () => input.click());

  input.addEventListener('change', function () {
    const file = this.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = function (e) {
      hasImage = true;

      // Replace box content with image + X button
      box.innerHTML = `
        <img src="${e.target.result}" style="
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 12px;
          display: block;
        ">
        <button class="upload-remove-btn" id="removeImageBtn" aria-label="Remove image">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M1 1L9 9M9 1L1 9" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      `;

      box.classList.remove('th-c-images__upload-tile--placeholder');

      // Change button text
      btn.textContent = 'Replace image';

      // X button — clear image
      document.getElementById('removeImageBtn').addEventListener('click', (e) => {
        e.stopPropagation();
        clearImage();
      });
    };

    reader.readAsDataURL(file);
  });

  function clearImage() {
    hasImage = false;

    // Reset box back to placeholder
    box.innerHTML = `
      <svg class="th-customiser__icon th-customiser__icon--plus-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.473751 10C0.473751 9.50245 0.877098 9.0991 1.37465 9.0991L18.6255 9.0991C19.1231 9.0991 19.5264 9.50245 19.5264 10C19.5264 10.4976 19.1231 10.9009 18.6255 10.9009L1.37465 10.9009C0.877098 10.9009 0.473751 10.4976 0.473751 10Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0001 0.473671C10.4976 0.47367 10.901 0.877017 10.901 1.37457V18.6254C10.901 19.123 10.4976 19.5263 10.0001 19.5263C9.50253 19.5263 9.09918 19.123 9.09918 18.6254V1.37457C9.09918 0.877018 9.50253 0.47367 10.0001 0.473671Z" fill="white"/>
      </svg>
    `;

    box.classList.add('th-c-images__upload-tile--placeholder');

    // Reset button text
    btn.textContent = '+ Add an image';

    // Reset file input so same file can be re-selected
    input.value = '';
  }
}
function accordionOpen() {
  const targets = ['WATCH THE VIDEO', 'DEVELOPMENT AND FADING'];

  document.querySelectorAll('.accordion-box details').forEach(function (details) {
    const title = details.querySelector('summary span')?.textContent.trim();
    if (targets.includes(title)) {
      details.open = true;
      details.setAttribute('aria-expanded', 'true');
    }
  });
}

document.addEventListener('DOMContentLoaded', accordionOpen);


(function () {
  const modal = document.createElement('div');
  modal.id = 'upsell-lightbox';
  modal.innerHTML = `
    <div class="upsell-lightbox__overlay">
      <button class="upsell-lightbox__close" aria-label="Close">&#x2715;</button>
      <img class="upsell-lightbox__img" src="" alt="">
    </div>
  `;
  document.body.appendChild(modal);

  const lightboxImg = modal.querySelector('.upsell-lightbox__img');

  function openLightbox(src, alt) {
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    modal.style.display = 'none';
    lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeLightbox();
  });

  modal.querySelector('.upsell-lightbox__close').addEventListener('click', closeLightbox);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeLightbox();
  });

  function initZoomButtons() {
    document.querySelectorAll('.upsell-zoom-button:not([data-zoom-init])').forEach(btn => {
      btn.setAttribute('data-zoom-init', 'true');
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.upsell-image-wrap');
        const img = wrap.querySelector('img');
        const zoomSrc = img.dataset.zoomSrc || img.src;
        openLightbox(zoomSrc, img.alt);
      });
    });
  }

  // Watch for upsell items being injected into the DOM
  const observer = new MutationObserver(() => {
    if (document.querySelector('.upsell-zoom-button:not([data-zoom-init])')) {
      initZoomButtons();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also catch cart events and run on DOM ready as fallback
  document.addEventListener('cart:updated', initZoomButtons);
  document.addEventListener('cart:refresh', initZoomButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoomButtons);
  } else {
    initZoomButtons();
  }

})();